(function () {
  'use strict';

  var FEATURE = 'ah_mobile_collection_v1';
  var SOURCE_KEY = 'ah-mobile-collection-source';
  var ATTRIBUTED_KEY = SOURCE_KEY + '-attributed';

  function storageGet(storage, key) {
    try { return storage.getItem(key); } catch (error) { return null; }
  }

  function storageSet(storage, key, value) {
    try { storage.setItem(key, value); } catch (error) {}
  }

  function pushEvent(name, details) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name, feature_id: FEATURE }, details || {}));
  }

  function cardDetails(element) {
    var card = element.closest('[data-ah-collection-card]');
    return card ? {
      product_id: card.dataset.productId,
      product_title: card.dataset.productTitle,
      collection_handle: card.dataset.collectionHandle
    } : {};
  }

  function rememberCollectionSource(details) {
    storageSet(window.sessionStorage, SOURCE_KEY, JSON.stringify(details));
  }

  function attributeCart() {
    var source = storageGet(window.sessionStorage, SOURCE_KEY);
    if (!source || storageGet(window.sessionStorage, ATTRIBUTED_KEY) === source) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { '_cro_mobile_collection_v1': FEATURE } }),
      credentials: 'same-origin',
      keepalive: true
    }).then(function (response) {
      if (response.ok) storageSet(window.sessionStorage, ATTRIBUTED_KEY, source);
    }).catch(function () {});
  }

  function initCollection() {
    if (!document.body.classList.contains('template-collection')) return;
    if (!window.matchMedia('(max-width: 767px)').matches) return;

    pushEvent('ah_collection_view', {
      collection_handle: document.querySelector('[data-ah-collection-card]')?.dataset.collectionHandle || '',
      visible_products: document.querySelectorAll('[data-ah-collection-card]').length
    });

    document.addEventListener('click', function (event) {
      var productLink = event.target.closest('[data-ah-collection-card] a[href*="/products/"]');
      if (productLink) {
        var linkDetails = cardDetails(productLink);
        rememberCollectionSource(linkDetails);
        pushEvent('ah_collection_product_click', linkDetails);
      }

      var quickAdd = event.target.closest('[data-ah-collection-card] [type="submit"], [data-ah-collection-card] [aria-controls^="Quickview-"]');
      if (quickAdd) {
        var addDetails = cardDetails(quickAdd);
        rememberCollectionSource(addDetails);
        pushEvent('ah_collection_quick_add', addDetails);
      }

      var filterButton = event.target.closest('.facet-sticky [aria-controls="FacetDrawerSticky"]');
      if (filterButton) pushEvent('ah_collection_filter_open');
    });

    document.addEventListener('change', function (event) {
      if (event.target.matches('[name="sort_by"]')) {
        pushEvent('ah_collection_sort_change', { sort_by: event.target.value });
      }
    });
  }

  document.addEventListener('ajaxProduct:added', attributeCart);

  function init() {
    initCollection();
    if (document.body.classList.contains('template-product') && storageGet(window.sessionStorage, SOURCE_KEY)) {
      document.addEventListener('ajaxProduct:added', attributeCart, { once: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

